<template>
  <div class="tech_advantages_mobile">
    <h1>智能科技 变革未来</h1>
    <p class="topP">以无人化、集群化、智能化为产品理念，打造全空间、全方位产业解决方案</p>
    <div class="btnCom">
      <span class="txt" @click="navigateToAboutUs">了解华软 ></span>
    </div>
    <el-row class="stats">
      <el-col :span="12" class="relative" style="margin-bottom: 16PX;">
        <div class="stat_item" style="justify-content: right;padding-right: 60PX;">
          <!-- <img src="path/to/icon1.png" alt="专利数量"> -->
          <img src="@/assets/home/zhuanNum.png" alt="" />
          <div>
            <div class="num">
              500<span class="sup">+</span>
            </div>
            <div class="stat-label">专利数量</div>
          </div>

        </div>
        <div class="div_line"></div>
      </el-col>
      <el-col :span="12" style="margin-bottom: 16PX;">
        <div class="stat_item" style="padding-left: 50PX;">
          <img src="@/assets/home/proType.png" alt="" />
          <div style="text-align: left;">
            <div class="num">
              80<span class="sup">+</span>
            </div>
            <div class="stat-label">产品类型</div>
          </div>
        </div>
      </el-col>
      <el-col :span="12" class="relative">
        <div class="stat_item" style="justify-content: right;padding-right: 60PX;">
          <img src="@/assets/home/haveUser.png" alt="" />
          <div>
            <div class="num">
              300<span class="sup">+</span>
            </div>
            <div class="stat-label">研发员工</div>
          </div>
        </div>
        <div class="div_line"></div>
      </el-col>
      <el-col :span="12">
        <div class="stat_item" style="padding-left: 50PX;">
          <img src="@/assets/home/flyHour.png" alt="" />
          <div style="text-align: left;">
            <div class="num">
              50<span class="sup" style="right: -10PX;">万+</span>
            </div>
            <div class="stat-label">运行时长</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <h2 class="hexin">核心技术优势</h2>
    <div class="heTxt">专注于为用户提供全空间“无人化、集群化、智能化”行业产品和解决方案，助力用户实现数智化转型升级</div>
    <el-row class="advantages">
      <el-col :span="24" class="col_item">
        <div class="advantage_item">
          <img src="@/assets/home/noPer.png" alt="无人值守" class="advantage-icon" />
          <h3>具身智能</h3>
        </div>
        <p>具有无人系统大脑、小脑及执行机构核心全要素全域技术，具备多模态自主感知、自主决策、智能执行能力，实现全域空间无人体系和装备复杂场景应用能力。</p>
      </el-col>
 
      <el-col :span="24" class="col_item">
        <div class="advantage_item">
          <img src="@/assets/home/aiChu.png" alt="智能处理" class="advantage-icon" />
          <h3>群体智能</h3>
        </div>
        <p>具有陆、海、空不同空间异构无人系统及装备的自主集群协同与作业能力，具备强鲁棒性、可扩展性、自组织与适应性能力，实现泛化全域空间多元复杂应用场景无人自主高效交互和作业。</p>
      </el-col>
      <!-- <el-col :span="24" class="col_item">
        <div class="advantage_item">
          <img src="@/assets/home/safe.png" alt="安全可靠" class="advantage-icon" />
          <h3>安全可靠</h3>
        </div>
        <p>全方位安全防护，确保系统运行稳定可靠</p>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    navigateToAboutUs() {
      this.$router.push({ path: '/about_us' });
    }
  }
}
</script>

<style lang="scss" scoped>
.tech_advantages_mobile {

  text-align: center;
  padding: 40PX 16PX;
  font-family: PingFang SC;
  letter-spacing: 0PX;
  opacity: 1;
  // width: 1200px;
  margin-left: auto;
  margin-right: auto;
  /* 可选：保证内容不会溢出 */
  box-sizing: border-box;

  h1 {

    font-size: 16PX;
    font-weight: bold;

    color: #1E242A;
    margin-bottom: 6PX;
  }

  .topP {
    opacity: 0.6;
    font-size: 10PX;
    /* 1E242A */
    color: #1E242A;
    margin-bottom: 10PX;
  }

  .btnCom {
    opacity: 0.4;
    font-size: 12PX;
   
    margin-bottom: 20PX;
    .txt {
       cursor: pointer;
    }
  }

  .relative {
    position: relative;
  }

  .stats {
    margin-bottom: 40PX;

    .stat_item {
      text-align: center;
      display: flex;
      //   justify-content: center;
      align-items: center;
      gap: 12PX;
      // padding-left: 12%;

      img {
        width: 44PX;
        height: 44PX;
      }

      .stat-label {
        font-size: 8PX;
      }


      .num {
        font-size: 18PX;
        font-weight: bold;
        letter-spacing: 0PX;
        position: relative;
        color: #1E242A;

        .sup {
          position: absolute;
          color: #1E242A;
          // right: 0PX;
          padding-left: 3px;
          font-size: 10PX;
          font-weight: normal;
          color: #1E242A;
          font-weight: bold;
          line-height: 16PX;
          letter-spacing: 0PX;
        }
      }
    }

    .div_line {
      position: absolute;
      right: 0px;
      top: 15PX;
      border-radius: 5PX;
      width: 2PX;
      height: 20PX;
      background: rgba(15, 107, 246, 0.1);
    }
  }

  .hexin {
    font-family: PingFang SC;
    font-size: 16PX;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0PX;

    font-variation-settings: "opsz" auto;
    color: #1E242A;
  }

  .heTxt {
    opacity: 0.6;
    font-size: 10PX;
    line-height: 14PX;
    letter-spacing: 0PX;
    margin-top: 6PX;
    color: #1E242A;
    margin-bottom: 20PX;
  }

  .advantages {
    // padding: 0PX 18.75% ;
    // background: linear-gradient(180deg, #F4F6F9 -41%, rgba(255, 255, 255, 0.01) 134%);
    // border: 1px solid rgba(15, 107, 246, 0.08);
    border-radius: 8px;
    background: linear-gradient(180deg, rgba(244, 246, 249, 0.6) 0%, rgba(244, 246, 249, 0.1) 99%);
    border: 1px solid rgba(15, 107, 246, 0.08);
    .txt {
      font-size: 10PX;
    }

    .col_item {
      // background: linear-gradient(180deg, #F4F6F9 -111%, rgba(255, 255, 255, 0.01) 164%);
      border-bottom: 1PX solid rgba(15, 107, 246, 0.08);

      // &:nth-child(1) {
        // border-right: none;
      //   border-bottom: none;
      // }

      &:nth-child(2) {
        border-bottom: none;

      }

      &:nth-child(4) {
        border-top: none;
      }
    }

    .advantage_item {
      padding: 16PX;
      padding-bottom: 0PX;
      display: flex;
      align-items: center;
      gap: 9PX;

      border-radius: 8PX;

      .advantage-icon {
        width: 32PX;
        height: 32PX;
      }

      h3 {
        font-family: PingFang SC;
        font-size: 12PX;
        font-weight: bold;
        line-height: normal;
        text-align: center;
        letter-spacing: normal;
        color: #1E242A;
        padding-bottom: 6PX;
      }

      p {
        font-family: PingFang SC;
        font-size: 16PX;
        font-weight: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1E242A;
        margin-top: 10PX;
      }
    }

    p {
      padding-left: 58PX;
      padding-bottom: 20PX;
      text-align: left;
      font-size: 10PX;
      padding-right: 16PX;
    }
  }


}
</style>